import { useMutation } from '@apollo/client/react';
import { UpdateProjectStatusDocument } from './mutation.gql';
export const useUpdateProjectStatus = () => {
    const [mutate, state] = useMutation(UpdateProjectStatusDocument);
    const updateProjectStatus = (id, status) => mutate({
        variables: { id, status },
        optimisticResponse: {
            updateFileSystemProject: {
                __typename: 'FileSystemProject',
                id,
                status,
            },
        },
        update(cache, { data }) {
            const { updateFileSystemProject } = data || {};
            if (updateFileSystemProject) {
                const { status: newStatus } = updateFileSystemProject;
                cache.modify({
                    id: cache.identify({ id, __typename: 'FileSystemProject' }),
                    fields: {
                        status() {
                            return newStatus;
                        },
                        updatedAt() {
                            return new Date().toISOString();
                        },
                    },
                });
            }
        },
    });
    return [updateProjectStatus, state];
};
